import { createContext, useContext, useState, useEffect } from 'react'
import { supabase } from '../utils/supabase'
import { setCurrentUser } from '../utils/auditoria'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  async function loadProfile(userId) {
    const { data } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single()
    setProfile(data)
    // Grava no localStorage pra o storage.js saber quem tá salvando/
    // deletando pedidos (usado no histórico de auditoria)
    if (data) setCurrentUser({ username: data.username, role: data.role })
    else      setCurrentUser(null)
  }

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      if (session?.user) loadProfile(session.user.id).finally(() => setLoading(false))
      else setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
      if (session?.user) loadProfile(session.user.id)
      else setProfile(null)
    })

    return () => subscription.unsubscribe()
  }, [])

  async function login(usuario, senha) {
    const email = `${usuario.trim()}@minideck.local`
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: senha })
    if (error) return { erro: 'Usuário ou senha incorretos' }
    await loadProfile(data.user.id)
    return { ok: true }
  }

  async function logout() {
    await supabase.auth.signOut()
    setUser(null)
    setProfile(null)
    setCurrentUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, profile, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
